import { CardModel } from '../../../models/card.model';
import { TComponentParamsGeneral, TStringField } from '../../../types/sitecore.types';
import { TStoriesFields, TStoriesProps } from '../types/blogNews.types';
import { TCardProps } from '../../../types/card.types';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-react';
import { ImageField, THeadingTag } from '../../../types/types';
import { getFollowingHTag } from '../../../utils/seo.utils';

export class StoriesModel {
  private readonly fields?: TStoriesFields;
  private readonly rendering?: ComponentRendering;
  private readonly params?: TComponentParamsGeneral;

  constructor(props: TStoriesProps) {
    this.fields = props?.fields;
    this.rendering = props?.rendering;
    this.params = props?.params;
  }

  get title(): TStringField | undefined {
    return this.fields?.title;
  }

  get content(): TStringField | undefined {
    return this.fields?.subtitle;
  }

  get cards(): TCardProps[] {
    const cardList = this.fields?.items;
    return cardList?.map((el: TCardProps) => new CardModel(el).all) || [];
  }

  get dataSource(): string | undefined {
    return this.rendering?.dataSource;
  }

  get isUnreleased(): boolean | undefined {
    return !!this.fields?.isComponentUnreleased;
  }

  get defaultCardImage(): ImageField | undefined {
    return this.fields?.defaultCardImage;
  }

  get headingTag(): THeadingTag {
    return (this.params?.headingTag?.toLowerCase() as THeadingTag) || 'h2';
  }

  get cardHeadingTitleTag(): THeadingTag {
    return getFollowingHTag(this.headingTag);
  }
}
